let uk = {
  public_id: "8c1f9360-bf36-47e4-a0c2-011ad43e2a04",
  template: "nord",
  campaign: "920c69f6-a24a-49f2-a455-3ab5a032eaae",
  name: "Currently Running on Google",
  flow: "PIN_FLOW",
  approach: "DEFAULT",
  prep_step: false,
  supported_languages: {
    en: "en",
  },
  country_code: "gb",
  country_name: "UK",
  logo_url: "https://d388jo7ckl8y3b.cloudfront.net/pages/page_logo__4737.png",
  logo_position: "CENTER",
  logo_size: "Small",
  logo_under_button: false,
  texts: {
    en: [
      {
        title: "The most advanced VPN",
        sec_title: "Secure your connection today with NordVPN",
        description: "Insert your mobile number to secure your network.",
        paragraph_under_button:
          "NordVPN is a virtual private network (VPN) service that improves online privacy and security by encrypting internet traffic and masking users' IP addresses. This allows users to bypass geo-restrictions, access content from anywhere in the world and surf the web anonymously. The service is based on a monthly subscription and is priced at £14 including VAT. You will receive a PIN code that you must enter to confirm payment and activate your subscription. The subscription can be canceled at any time by sending STOP NORD to the number XXXX. if you need support, contact us by email support.uk@noju.io or call 02030265044. This service is provided by Nordvpn S.A.",
        button_text: "Continue",
        button_caption: "Price £14 with VAT per month (£3.5/week)",
        button_loading_text: "Checking",
      },
      {
        title: "The most advanced VPN",
        sec_title: "Secure your connection today with NordVPN",
        description: "Enter received verification code",
        paragraph_under_button:
          "NordVPN is a virtual private network (VPN) service that improves online privacy and security by encrypting internet traffic and masking users' IP addresses. This allows users to bypass geo-restrictions, access content from anywhere in the world and surf the web anonymously. The service is based on a monthly subscription and is priced at £14 including VAT. You will receive a PIN code that you must enter to confirm payment and activate your subscription. The subscription can be canceled at any time by sending STOP NORD to the number XXXX. if you need support, contact us by email support.uk@noju.io or call 02030265044. This service is provided by Nordvpn S.A.",
        button_text: "Confirm",
        button_caption: "Price £14 with VAT per month (£3.5/week)",
        button_loading_text: "Checking",
      },
    ],
  },
  translations: {
    en: {
      1: "Online Security",
      2: "Hide Your IP",
      3: "Fast VPN",
      4: "Global Coverage",
      5: "Multiple Devices",
      6: "No User Tracking",
      terms_agreement_text: "I agree to the Terms of Use",
      terms_text: "T&C",
      policy_text: "Privacy Policy",
      contact_us_text: "Contact Us",
    },
  },
  titles_color: "#000000",
  text_color: "black",
  font_family: "",
  button_text_color: "white",
  // button_primary_color: "#E02F1F",
  button_primary_color: "#3E5FFF",

  background_color: "#FFF",
  header_background_color: "#FFF",
  background_image: null,
  player_image:
    "https://d202f37y8mzl74.cloudfront.net/dh-games/page_configurations/2023/9/26/page_config_fi_-494.png",
  text_above_player: "",
  featured_image:
    "https://d388jo7ckl8y3b.cloudfront.net/images/nord_featured.png",
  bottom_text: "",
  terms_text: "",
  terms_url: "https://mobilecheckout.shop/terms-of-service.html",
  contact_us_url: "contact-us.html",
  policy_text: "",
  policy_url: "https://mobilecheckout.shop/privacy-policy.html",
  terms_agreement_text: "I agree to the Terms of Use",
  sticky_top_right_text: "",
  terms_checkbox_switch: false,
  terms_autocheck_with_click: false,
  default_terms_switch_status: true,
  append_terms_link_to_consent: false,
  show_carriers: false,
  show_rating: true,
  show_country_flag: true,
  // "layout": "BOXED",
  layout: "FULL_WIDTH",
  boxed_background_color: "#ffffff",
  carriers: null,
  validate_msisdn: true,

  // new attributs
  // "button_gradient": "linear-gradient(92.32deg, #7538F0 -3.12%, #F233E7 100.39%)",
  button_font_size: "20px",
  show_footer: true,
  footer_content:
    '<span style="color: #FFF;">Powered by</span> <a href="https://dcb-checkout.com" target="_blank" style="text-decoration: none; color: #fff; font-weight: bold;">DCB <span style="background: linear-gradient(92.32deg, #7538F0 -3.12%, #F233E7 100.39%); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">CHECKOUT</span></a>',
  footer_bg_color: "#000",
  footer_text_color: "#FFF",
  show_step_indicator: true,
  animation_enabled: false,
  phone_mask: "### ######",
};
export default uk;
